import { alignNameMarkers } from "./studioLinkedText";
import { followAttachedArtwork } from "./studioModel";
import { alignHeadingWinglets, retainHeadingAdjustments } from "./studioHeadings";
import { stampTouchedPages } from "./studioExportPages";
import { affectedPages, applyOps, diffDocs } from "./core/docOps";

// Local application trusts the document it was computed from; preconditions
// for the server come from diffing authored states.
export const strip = (ops) => ops.map(({ expect, ...op }) => op);

// Turn an edit made on the displayed document into the authored design:
// attachments follow, then only what the edit changed is applied to the
// saved design, so layout derived elsewhere is never swept into a save.
export function resolveEdit(prev, next, authored, content, now = new Date()) {
  const settled = alignHeadingWinglets(retainHeadingAdjustments(prev, alignNameMarkers(followAttachedArtwork(prev, next), content), content), content);
  const local = strip(diffDocs(prev, settled));
  if (!local.length) return null;
  const after = applyOps(authored, local).doc;
  return { before: authored, after: stampTouchedPages(authored, after, affectedPages(authored, local), content, now) };
}

// The history/save record for a committed change.
export function changeRecord(before, after) {
  return { ops: diffDocs(before, after), inverse: diffDocs(after, before) };
}
